import { Component } from '@angular/core';
import { first } from 'rxjs/operators';

import { User } from '@app/_models';
import { UserService, AuthenticationService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({ templateUrl: 'dashboard.component.html' })
export class DashboardComponent {
    module: any = 'journey';
    participant: any;
    editProfile: boolean = false;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            let module = params.get('module');
            let participant = params.get('participant');
            let editProfile = params.get('edit');
            if (module) {
                this.module = module;
            }
            if (participant && module == 'community') {
                this.editProfile = true;
                this.participant = participant;
            }
            if (editProfile == 'edit' && module == 'profile') {
                this.editProfile = true;
            }
        });
    }

    switchToModule(moduleName) {
        this.module = moduleName;
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }
}